export const Section = ({ children }: { children: React.ReactNode }) => (
  <section className="flex-1 md:min-h-screen min-h-[calc(100vh-80px)]">{children}</section>
);
